
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

/**
 * 1) GET /v1/tenant/partners
 *    Devuelve un listado de Partners. Con `includeGlobalAdmin=true` el backend
 *    suma también al tenant GLOBAL_ADMIN al listado (cada item trae su
 *    `TenantType` real, así que el frontend puede diferenciar por
 *    `TenantType.name`).
 */
export function getPartners(token: string, includeGlobalAdmin = false) {
    return axios.get(`${API_URL}/v1/tenant/partners`, {
        headers: { Authorization: `Bearer ${token}` },
        params: includeGlobalAdmin ? { includeGlobalAdmin: true } : undefined,
    });
}

/**
 * 2) GET /v1/tenant/customers?tenantId={id}
 *    Devuelve los customers del tenant que reciba como parámetro.
 */
export function getCustomers(token: string, tenantId: number) {
    return axios.get(`${API_URL}/v1/tenant/customers?tenantId=${tenantId}`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

/**
 * 3) GET /v1/kontroledge/saveorder
 *    Devuelve las órdenes de kontrol edge que están guardadas para después.
 */
export function getSaveOrder(token: string ) {
    return axios.get(`${API_URL}/v1/kontroledge/saveorder`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

/**
 * 3) GET /v1/kontroledge/alerts
 *    Devuelve las notificaciones de kontroledge
 */
export function getAlerts(token: string ) {
    return axios.get(`${API_URL}/v1/kontroledge/monitoring/alerts`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

